export const BootstrapPagination = 'BootstrapPagination';
export const Customer = 'Customer';
export const CustomersPaginated = 'CustomersPaginated';
export const Me = 'Me';
export const Property = 'Property';
export const ScreenSize = 'ScreenSize';
export const User = 'User';
